import { __read } from 'tslib';
import * as React from 'react';

function useKeyPress(targetKey, ref) {
    var _a = __read(React.useState({
        keyboardEvent: null,
        pressed: false,
    }), 2), keyPressed = _a[0], setKeyPressed = _a[1];
    function keyDownHandler(e) {
        if (e.key === targetKey) {
            e.preventDefault();
            setKeyPressed({
                keyboardEvent: e,
                pressed: true,
            });
        }
    }
    function keyUpHandler(e) {
        if (e.key === targetKey) {
            e.preventDefault();
            setKeyPressed({
                keyboardEvent: e,
                pressed: false,
            });
        }
    }
    var addKeyEvents = React.useCallback(function (refOrWindow) {
        refOrWindow.addEventListener('keydown', keyDownHandler);
        refOrWindow.addEventListener('keyup', keyUpHandler);
        return function () {
            refOrWindow.removeEventListener('keyup', keyUpHandler);
            refOrWindow.removeEventListener('keydown', keyDownHandler);
        };
    }, []);
    React.useEffect(function () {
        if (!ref && typeof window !== 'undefined') {
            return addKeyEvents(window);
        }
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            return addKeyEvents(ref.current);
        }
    }, [ref, addKeyEvents]);
    return keyPressed;
}

export { useKeyPress };
//# sourceMappingURL=useKeyPress.esm.js.map
